import React from 'react';
import { Box, Chip } from '@mui/material';

/**
 * @param {string[]} labels
 * @param {(text: string) => void} onSelect
 * @param {boolean} disabled
 */
const SuggestedPromptChips = ({ labels = [], onSelect, disabled = false }) => {
  if (!labels.length) return null;
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
      {labels.map((label) => (
        <Chip
          key={label}
          label={label}
          size="small"
          onClick={() => !disabled && onSelect?.(label)}
          disabled={disabled}
          sx={{
            borderRadius: 2,
            backgroundColor: 'rgba(22, 35, 58, 0.95)',
            color: '#E6EDF7',
            border: '1px solid rgba(148, 163, 184, 0.28)',
            '&:hover': {
              borderColor: '#40D2B7',
              backgroundColor: 'rgba(32, 52, 82, 0.98)',
            },
            maxWidth: '100%',
            height: 'auto',
            '& .MuiChip-label': { whiteSpace: 'normal', py: 0.5, px: 1 },
          }}
        />
      ))}
    </Box>
  );
};

export default SuggestedPromptChips;
